import { Routes } from '@angular/router';
import { PRODUCTS_ROUTES } from '@features/products/products.routes';
import { APP_SLUGS, MAIN_SLUGS, PRODUCTS_SLUGS } from './routes.types';

export const COMMERCE_ROUTES: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: PRODUCTS_SLUGS.catalog,
    },
    ...PRODUCTS_ROUTES,
    // Payments (incl. taxes) is hidden: its code stays in features/payments, old URLs go to Catalog.
    {
        path: MAIN_SLUGS.PAYMENT,
        children: [{ path: '**', redirectTo: `/${APP_SLUGS.MAIN}/${MAIN_SLUGS.commerce}` }],
    },
];
